import { createContext } from "react";

export interface PnrDataContextValue {
    isEnterPnr: boolean;
    setIsEnterPnr: (isEnterPnr: boolean) => void;
    isIrctcPnrHalfCardOpen: boolean;
    setIsIrctcPnrHalfCardOpen: (isOpen: boolean) => void;
}

const noop = (): void => void 0;

export const PnrDataContext = createContext<PnrDataContextValue>({
    isEnterPnr: false,
    setIsEnterPnr: noop,
    isIrctcPnrHalfCardOpen: false,
    setIsIrctcPnrHalfCardOpen: noop,
});

if (__DEV__) {
    PnrDataContext.displayName = "PnrDataContext";
}
